import { Table } from '@tanstack/react-table';
import { TableFilter } from '../../shared/filter';
import {
  TableRoofChipList,
  TableRoofFilter
} from '../../../compound/tables/presentation/table/roofs/shared';
import { DataTableResults } from '../../shared/results';
import { DataTableSearch } from '../../shared/search';
import { Bonus } from '@pxtra-client-lib-legacy/gen';

export const BonusOverviewToolBar = <T extends Bonus>({
  table,
  canDeselect = true,
  customHeadline
}: {
  table: Table<T>;
  canDeselect?: boolean;
  customHeadline?: string;
}) => {
  return (
    <div className="flex items-center min-h-12 justify-between py-3">
      <DataTableResults customHeadline={customHeadline} table={table} canDeselect={canDeselect} />
      <TableRoofChipList
        chips={table.getState().columnFilters.map((filter) => {
          const column = table.getColumn(filter.id);
          const filterOptions = column?.columnDef.meta?.filterOptions;

          let label = String(filter.value);
          if (filterOptions) {
            const option = filterOptions.find((opt) => String(opt.value) === String(filter.value));
            if (option) {
              label = option.text;
            }
          }

          return {
            label: label,
            value: filter.id,
            onDelete: () => {
              table.getColumn(filter.id)?.setFilterValue(undefined);
              table.resetRowSelection();
            }
          };
        })}
        justify="flex-start"
        sx={{
          width: '500px'
        }}
      />

      <DataTableSearch table={table} />
      <TableRoofFilter renderFilter={() => <TableFilter table={table} />} />
    </div>
  );
};
